// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

/* eslint-disable no-new */
let umtdivs = document.getElementsByClassName('umt-app');
for (var i = 0; i < umtdivs.length; i++) {
    new Vue({
        el: umtdivs[i],
        components: {App}
    })
}



// WEBPACK FOOTER //
// ./src/main.js